import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id:"",
  name: "",
  district: "",
  email: "",
  phone: "",
  roles: [],
  roleNames: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.roles = action.payload.roles ?? [];
      state.district = action.payload.district;
      state.roleNames = (action.payload.roles ?? []).map((role) => role.name);
      state.udyam = action.payload.udyam;
    },
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
